import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Integrations',
  href: '#integrations'
}, {
  label: 'How it works',
  href: '#how-it-works'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-cream/90 backdrop-blur-md border-b border-ink/10' : 'border-b border-transparent'}`} data-id="element-112">
      <nav className="mx-auto flex max-w-[1200px] items-center justify-between px-5 py-4 md:px-8" data-id="element-113">
        <a href="#top" className="flex items-center gap-2" aria-label="oursignals home" data-id="element-114">
          <span className="relative flex h-3 w-3" data-id="element-115">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-signal opacity-60" data-id="element-116" />
            <span className="relative inline-flex h-3 w-3 rounded-full bg-signal" data-id="element-117" />
          </span>
          <span className="font-display text-xl font-semibold tracking-tight" data-id="element-118">
            oursignals
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex" data-id="element-119">
          {links.map(l => <a key={l.href} href={l.href} className="text-sm font-medium text-ink/70 transition-colors hover:text-ink" data-id="element-120">
              {l.label}
            </a>)}
        </div>

        <div className="hidden items-center gap-3 md:flex" data-id="element-121">
          <a href="#pricing" className="text-sm font-semibold text-ink transition-colors hover:text-signal" data-id="element-122">
            Sign in
          </a>
          <a href="#cta" className="rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-cream transition-colors hover:bg-signal" data-id="element-123">
            Start free
          </a>
        </div>

        <button className="flex h-10 w-10 items-center justify-center rounded-full border border-ink/15 md:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-124">
          {open ? <XIcon className="h-5 w-5" data-id="element-125" /> : <MenuIcon className="h-5 w-5" data-id="element-126" />}
        </button>
      </nav>

      {open && <div className="border-t border-ink/10 bg-cream px-5 py-4 md:hidden" data-id="element-127">
          <div className="flex flex-col gap-1" data-id="element-128">
            {links.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="rounded-lg px-2 py-3 text-base font-medium text-ink/80 hover:bg-ink/5" data-id="element-129">
                {l.label}
              </a>)}
            <a href="#cta" onClick={() => setOpen(false)} className="mt-2 rounded-full bg-ink px-5 py-3 text-center text-sm font-semibold text-cream" data-id="element-130">
              Start free
            </a>
          </div>
        </div>}
    </header>;
}